import { gql } from '@apollo/client';
import { SITE_FIELDS } from './Site.fragment';

export const ADSLOT_FIRM = gql`
  fragment AdSlotFirmFields on showcaseAdslotFirm {
    id
    firm {
      id
      name
    }
  }
`;

export const ADSLOT_ITEM = gql`
  fragment AdSlotItemFields on showcaseAdslotItem {
    id
    item {
      id
      description1
      description2
    }
  }
`;

export const ADSLOT_FIELDS = gql`
  ${ADSLOT_FIRM}
  ${ADSLOT_ITEM}
  ${SITE_FIELDS}
  fragment AdSlotFields on showcaseAdslot {
    id
    startDate
    endDate
    title1
    title2
    headerThinIndex
    url
    buttonText
    buttonColor
    buttonTextColor
    backgroundTextColor
    listingType
    backgroundColor
    displayEffect
    isPaused
    googleAnalyticsTag
    presentedByColor
    presentedByFontWeight
    logoHeight
    tagColor
    logoPadding
    dateCreated
    dateUpdated
    createdBy
    updatedBy
    firms {
      ...AdSlotFirmFields
    }
    items {
      ...AdSlotItemFields
    }
    sites {
      id
      siteId
      adslotId
      site {
        ...SiteFields
      }
    }
  }
`;
